import * as React from 'react'
import { FormattedMessage, WrappedComponentProps, injectIntl } from 'react-intl'
import './ReportDetails.scss'
import { Elements, Grid, TextButton } from '@tfo/common'
import classnames from 'classnames'
import { PropTypes } from 'mobx-react'

const { Heading4, Label } = Elements
const { GridCollapse, GridContainer } = Grid

export interface ReportDetailsProps {
	captionId: string
	captionData?: any
	availabilityId: string
	availabilityData?: any
	buttonId: string
	buttonIsSecondary: boolean
	onClickCallback?: Function
	showActionButton?: boolean
}

const ReportDetails: React.FunctionComponent<ReportDetailsProps &
	WrappedComponentProps> = props => {

	//set default values.
	props = { 
		showActionButton: true, 
		...props }

	return (
		<div className={'ReportDetails ReportDetails__Row'}>
			<GridCollapse className="TwoColumn">
				<GridContainer>
					<div className="TwoColumn__Column">
						{props.availabilityData && <Label className={'ReportDetails__Label'}>
							<FormattedMessage
								id={props.captionId}
								values={props.captionData}
							/>
						</Label>}
						{props.availabilityData && <Heading4>
							<FormattedMessage
								id={props.availabilityId}
								values={props.availabilityData}
							/>
						</Heading4>}
					</div>
					<div className="TwoColumn__Column">
						<GridCollapse>
							{props.showActionButton && (
								<TextButton
                                style= {({width: "100%"})}
									onClick={() => {
										if (props.onClickCallback) {
											props.onClickCallback()
										}
									}}
									className={classnames('ReportDetails__TextButton', {
										'TextButton--secondary': props.buttonIsSecondary,
									})}>
									<FormattedMessage id={props.buttonId} />
								</TextButton>
							)}
						</GridCollapse>
					</div>
				</GridContainer>
			</GridCollapse>
		</div>
	)
}

export default injectIntl(ReportDetails)
